import { j as a } from "./jsx-runtime-3tyXYecC.mjs";
import { d as i } from "./index-DspsydPg.mjs";
import { I as c } from "./icon-CvGUqXUP.mjs";
const r = "fab-", n = i.createLogger("<FabricIcon />");
function e(o) {
  return o.startsWith(r) ? o : (n.warn(`"${r}" prefix automatically added to icon name: "${o}"`), r + o);
}
const s = ({ name: o, ...t }) => /* @__PURE__ */ a.jsx(c, { ...t, name: e(o) });
s.displayName = "FabricIcon";
export {
  s as F
};
//# sourceMappingURL=fabric-icon-CNOLIwc_.mjs.map
